import { ReactNode } from 'react';
import { Select } from '@ardoq/select';
import { PaginationWithoutNumbersProps } from './types';
import { noop, uniq } from 'lodash';
import { PaginationWithoutNumbers } from './PaginationWithoutNumbers';
import {
  PageSelectorText,
  PaginationBarWithoutNumbersWrapper,
  PaginationWithoutNumbersArrowWrapper,
  RightSideText,
} from './atoms';

type PaginationBarWithoutNumbersProps = {
  pageSizeOptions?: number[];
  showPerPageSelector?: boolean;
  perPage?: number;
  onPageSizeChange?: (options: { perPage: number }) => void;
  showPagination?: boolean;
  perPageSuffix?: ReactNode;
  selectPerPageAriaLabel?: string;
} & PaginationWithoutNumbersProps;

export const PaginationBarWithoutNumbers = ({
  hasPreviousPage,
  hasNextPage,
  isDisabled,
  pageSizeOptions = [10, 25, 50, 100],
  showPerPageSelector,
  onPreviousPress = noop,
  onNextPress = noop,
  perPage,
  onPageSizeChange = noop,
  showPagination = true,
  previousButtonDataTestId,
  nextButtonDataTestId,
  currentPage,
  onFirstPagePress,
  previousLabel,
  nextLabel,
  perPageSuffix = ' / page',
  selectPerPageAriaLabel = 'Select results count per page',
}: PaginationBarWithoutNumbersProps) => {
  const options = uniq([...pageSizeOptions, perPage]).map(num => ({
    label: `${num}`,
    value: num,
  }));

  if (showPagination)
    return (
      <PaginationBarWithoutNumbersWrapper>
        <PaginationWithoutNumbersArrowWrapper>
          <PaginationWithoutNumbers
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onPreviousPress={onPreviousPress}
            onNextPress={onNextPress}
            isDisabled={isDisabled}
            previousButtonDataTestId={previousButtonDataTestId}
            nextButtonDataTestId={nextButtonDataTestId}
            onFirstPagePress={onFirstPagePress}
            currentPage={currentPage}
            previousLabel={previousLabel}
            nextLabel={nextLabel}
          />
        </PaginationWithoutNumbersArrowWrapper>
        <RightSideText>
          {showPerPageSelector && (
            <>
              <Select
                isDisabled={isDisabled}
                isSearchable={false}
                value={perPage}
                onValueChange={newPerPage =>
                  newPerPage && onPageSizeChange({ perPage: newPerPage })
                }
                options={options}
                aria-label={selectPerPageAriaLabel}
              />
              <PageSelectorText>{perPageSuffix}</PageSelectorText>
            </>
          )}
        </RightSideText>
      </PaginationBarWithoutNumbersWrapper>
    );
  return null;
};
